import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { getFormattedDate } from "../../Utils/utils";
import { useInitiatePayment } from "../../Hooks/AssesmentHooks";
import aidynamicimage from "././../../Assets/Icons/ai_dynamic.jpg";
import bigfiveimage from "././../../Assets/Icons/bigfive_personality.jpg";

export default function CheckoutPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const data = jwtDecode(token);

    const { mutate: initiatePayment, isLoading: isInitialPaymentLoading } =
      useInitiatePayment({
        handleOnSuccess: (data) => {
          console.log(data, "dddaaattaaa");
          window.location.href = data?.redirectUrl;
        },
        onError: () => {
          // messageApi.open({
          //   type: 'error',
          //   content: DEFAULT_ERROR_MESSAGE,
          // });
        },
      });

  console.log("Decoded Data:", data);
  const handleProceedToCheckout = async () => {
    console.log("Proceeding to checkout...");
    const payload = {
      company_interview_id: data?.company_interview_id,
      job_id: data?.job_details?.id,
    };
    await initiatePayment({ data: payload });
  };

  const handleCancelPayment = () => {
    console.log("Payment cancelled");
    window.open(`https://ipecsolutions.com/hirehub/`, "_self");
  };

  return (
    <div className="min-h-screen bg-[#f5f7f9]">
      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-8 py-12">
        <h1 className="mb-8">Review & Confirm</h1>

        <div className="flex gap-8 items-start">
          {/* Left Side - Product Card */}
          <div className="bg-[#e8edf2] border border-[#e8edf2] rounded p-6 w-[448px] flex-shrink-0">
            <div className="flex gap-4 items-start">
              {/* Product Image with Mask */}
              <div className="relative w-[170px] h-[127px] flex-shrink-0">
                {/* <div 
                  className="absolute inset-0 mask-alpha mask-intersect mask-no-clip mask-no-repeat"
                  style={{ 
                    maskImage: `url('${maskShape}')`,
                    maskSize: '152.234px 126.82px',
                    maskPosition: '0px 21.391px'
                  }}
                >
                  <img 
                    src={img21510153253} 
                    alt="AI Dynamic Interview" 
                    className="w-full h-full object-cover object-center"
                  />
                </div> */}
                <img
                          src={
                            data?.interview_type === "Master Your Interview"
                              ? aidynamicimage
                              : bigfiveimage
                          }
                          alt="AI Dynamic Interview"
                          className="w-full h-40 object-cover"
                        />
              </div>

              {/* Product Details */}
              <div className="flex-1">
                <h3 className="text-[#2e2c2c] mb-2">{data?.interview_type}</h3>
                <p
                  className="text-[#0071dc] text-[26px]"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  ₹{data?.fee}
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Order Summary */}
          <div className="bg-white rounded p-8 flex-1 shadow-sm">
            <div className="space-y-6">
              <div className="flex justify-between">
                <span className="text-[rgb(102,102,102)]">Date</span>
                <span>{getFormattedDate()}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-[#666666]">Name</span>
                <span>{data?.candidate_name}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-[#666666]">Email</span>
                <span>{data?.email}</span>
              </div>

              <div className="border-t border-dashed border-[#BABABA] pt-6">
                <div className="flex justify-between items-center">
                  <span className="text-[20px]">Total Amount</span>
                  <span
                    className="text-[20px]"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    ₹{data?.fee}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-8">
          <button
            onClick={handleCancelPayment}
            disabled={isInitialPaymentLoading}
            className="px-6 py-2.5 border border-[#0071dc] text-[#0071dc] rounded-md hover:bg-[#0071dc] hover:bg-opacity-5 transition-colors"
          >
            Cancel Payment
          </button>
          <button
            onClick={handleProceedToCheckout}
            className="px-6 py-2.5 bg-[#0071dc] text-white rounded-md hover:bg-[#0059b3] transition-colors"
          >
            Proceed to Checkout
          </button>
        </div>
      </main>
    </div>
  );
}
